/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AnalyticsStrictHttpResponse } from '../../analytics-strict-http-response';
import { AnalyticsRequestBuilder } from '../../analytics-request-builder';

import { AnalyticsProductionAnalysisResponseDto } from '../../models/analytics-production-analysis-response-dto';

export interface ProductionAnalysisControllerFindByProjectAndTenant$Params {
  tenant: string;
  projectId: string;
}

export function productionAnalysisControllerFindByProjectAndTenant(http: HttpClient, rootUrl: string, params: ProductionAnalysisControllerFindByProjectAndTenant$Params, context?: HttpContext): Observable<AnalyticsStrictHttpResponse<AnalyticsProductionAnalysisResponseDto>> {
  const rb = new AnalyticsRequestBuilder(rootUrl, productionAnalysisControllerFindByProjectAndTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('projectId', params.projectId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AnalyticsStrictHttpResponse<AnalyticsProductionAnalysisResponseDto>;
    })
  );
}

productionAnalysisControllerFindByProjectAndTenant.PATH = '/o2-analytics/production-analysis/{tenant}/project/{projectId}';
